import { forwardRef } from 'react';

type OwnProps = React.SVGProps<SVGSVGElement>;

const Wave = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <svg
    width="1144"
    height="208"
    viewBox="0 0 1144 208"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M628.067 174.982C315.162 92.7344 69.3033 101.091 0.232183 97.6305L1.04476 -0.00973379L1508.72 0.237794L1509.29 242.98C1173.93 287.969 997.882 272.188 628.067 174.982Z"
      fill="#EBFDF5"
    />
  </svg>
));

export default Wave;
